<template>
  <div>
    <div
      class="NCAcmi_check"
      :class="{ marTM: !isTop }"
    >
      <input
        :id="`activity-check-${unique}`"
        type="checkbox"
        class="NCAcmi_checkbox"
        @change="checkVipExample"
        :checked="checked"
        :disabled="checkboxDisabled"
      />
      <label
        :for="`activity-check-${unique}`"
        class="normal inline-label checklabel focus"
      >
        <span
          class="fntH6 bold"
          :style="{ color: checkboxDisabled ? '#bbbbbb' : '#ff6a07' }"
        >{{ displayText }} <em v-if="remainingNumber !== null">(잔여 {{ remainingNumber }})</em></span>
      </label>
    </div>
    <div class="padTSM">
      <select
        class="form-control NCAcmi_attendNum_box"
        :id="`activity-select-${unique}`"
        @change="changeActivityValue({ se_data: $event.target.value })"
        :value="se_data"
        :disabled="!checked || checkboxDisabled"
      >
        <option value="" hidden disabled>참여인원 선택</option>
        <option value="0">불참</option>
        <option
          v-for="number in numberOfAttendeesLimit"
          :key="`${example.se_code}_${number}`"
          :value="number"
        >{{ number }}명</option>
      </select>
    </div>
    <div class="NCAcmi_nameBox_wrap">
      <div class="NCAcmi_nameBox padBSM padTSM NCAcmi_nameBox_input" style="border-bottom:none;">
        <label
          :for="`activity-remarks-${unique}`"
          class="fntP"
        >실제 사용자<br>(타인 양도가능)*</label>
        <input
          type="text"
          :id="`activity-remarks-${unique}`"
          class="NCAcmi_checkInput01"
          placeholder="예) 홍길동(7480000)"
          @input="changeActivityValue({ remarks: $event.target.value })"
          :value="remarks"
          :disabled="remarksDisabled"
        />
      </div>
      <p class="fntE txtL txtR light colorGray">
        VIP 액티비티 모든 실참여자의 이름과 회원번호를 입력해주세요. <br>(6명 선택 시 6명 모두 다 입력 필요) 동반 가족이 이용 시, <br>본인의 ABO번호와 동반가족의 이름을 입력해 주세요.
      </p>
    </div>
  </div>
</template>

<script>
import { SURVEY, ATTENDING_LIST, SET_CHOICE_QUESTION, NUMBER_OF_ATTENDEES, GET_DATA_IDX_BY_TYPE, GET_ORIGINAL_IDX_BY_SEQ } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SurveyActivityExampleVip',
  props: {
    example: {
      type: Object,
      required: true
    },
    attendant: {
      type: Object,
      required: true
    },
    unique: {
      type: String,
      required: true
    },
    isTop: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState(SURVEY, {
      pinLevel: state => state.pin_level,
      originals: state => state.originals,
      golf: state => state.golf,
      spa: state => state.spa
    }),
    ...mapGetters(SURVEY, {
      attendingList: ATTENDING_LIST,
      // 총 참여 가능한 인원 수
      numberOfAttendees: NUMBER_OF_ATTENDEES,
      getDataIdx: GET_DATA_IDX_BY_TYPE,
      getOriginalIdx: GET_ORIGINAL_IDX_BY_SEQ,
    }),
    responseIdx() {
      return this.getDataIdx(this.attendant.type, this.attendant.type_seq);
    },
    displayText() {
      return this.example.display_text;
    },
    remainingNumber() {
      return this.example.remain_num;
    },
    choices() {
      return this.attendant.questions[this.example.sq_code];
    },
    choiceIdx() {
      return this.choices.findIndex(choice => choice.se_code === this.example.se_code)
    },
    choice() {
      return this.choices[this.choiceIdx];
    },
    checked() {
      return this.choice.checked;
    },
    se_data() {
      return this.choice.se_data || '';
    },
    remarks() {
      return this.choice.remarks || '';
    },
    checkboxDisabled() {
      return (this.remainingNumber < 1 && !this.isOriginalSelected) || (this.remainingNumberOfAttendees === 0 && Number(this.se_data) === 0);
    },
    remarksDisabled() {
      return !this.checked || Number(this.se_data) < 1;
    },
    originalSeData() {
      const originalIdx = this.getOriginalIdx(this.attendant.sr_seq);
      if(originalIdx === -1) return null;

      const originalQuestions = this.originals[originalIdx].questions;
      if(originalQuestions) {
        const originalChoices = originalQuestions[this.example.sq_code];
        if(originalChoices) {
          const originalChoice = originalChoices.find(originalChoice => originalChoice.se_code === this.example.se_code);
          return originalChoice ? originalChoice.se_data : null;
        }
      }
      return null;
    },
    isOriginalSelected() {
      return !!this.originalSeData;
    },
    // 해당하는 vip 액티비티 리스트
    vipActivities() {
      const { sq_code, se_code } = this.example;
      if(this.golf.some(info => info[0] === sq_code && info[1] === se_code)) {
        return this.golf;
      } else if(this.spa.some(info => info[0] === sq_code && info[1] === se_code)) {
        return this.spa;
      }
    },
    // 선택가능한 남은 인원 수
    remainingNumberOfAttendees() {
      let attendingCount = 0;
      const mainAttendants = this.attendingList.filter(response => ['E', 'P', 'S'].includes(response.type));
      mainAttendants.forEach(mainAttendant => {
        this.vipActivities.forEach(element => {
          const [sq_code, se_code] = element;
          const choices = mainAttendant.questions[sq_code];
          const vipChoice = choices.find(choice => choice.se_code === se_code);
          if(vipChoice) {
            attendingCount += Number(vipChoice.se_data);
          }
        });
      });
      return this.numberOfAttendees - attendingCount;
    },
    // 실제 잔여 인원 수 = 기존에 선택했던 인원 + 남아있는 잔여 인원 수
    realRemainingNumber() {
      return Number(this.originalSeData) + this.remainingNumber;
    },
    // 실제 선택 가능한 인원 수 = 선택 가능한 남은 인원 수 + 이 액티비티 선택한 인원 수
    realSelectableNumberOfAttendees() {
      return this.remainingNumberOfAttendees + Number(this.se_data);
    },
    // 참여 인원 제한
    numberOfAttendeesLimit() {
      return this.remainingNumber !== null ?
        Math.min(this.realRemainingNumber, this.realSelectableNumberOfAttendees) : this.realSelectableNumberOfAttendees;
    },
  },
  methods: {
    checkVipExample(e) {
      // 체크 해제 시 참여 인원 및 실 참여자 명 초기화
      const valueObj = e.target.checked ? { checked: e.target.checked } : { checked: e.target.checked, se_data: null, remarks: null };
      this.changeActivityValue(valueObj);
    },
    changeActivityValue(keyValue) {
      const choices = [...this.choices];
      choices[this.choiceIdx] = { ...this.choice, ...keyValue };
      this.$store.commit(`${SURVEY}/${SET_CHOICE_QUESTION}`, {
        idx: this.responseIdx,
        sq_code: this.example.sq_code,
        choices
      });

      if(this.remainingNumberOfAttendees === 0) {
        const mainAttendants = this.attendingList.filter(response => ['E', 'P', 'S'].includes(response.type));
        mainAttendants.forEach(mainAttendant => {
          this.vipActivities.forEach(element => {
            const [sq_code, se_code] = element;
            const choices = mainAttendant.questions[sq_code];
            const vipChoiceIdx = choices.findIndex(choice => choice.se_code === se_code);
            if(vipChoiceIdx > -1 && choices[vipChoiceIdx].checked && Number(choices[vipChoiceIdx].se_data) === 0) {
              const copyChoices = [...choices];
              copyChoices[vipChoiceIdx] = { ...choices[vipChoiceIdx], checked: false, se_data: null, remarks: null };
              this.$store.commit(`${SURVEY}/${SET_CHOICE_QUESTION}`, {
                idx: this.getDataIdx(mainAttendant.type, mainAttendant.type_seq),
                sq_code,
                choices: copyChoices
              });
            }
          });
        });
      }
    }
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyActivityExampleVip.vue